import React, { useCallback, } from 'react';
import { connect, } from 'react-redux';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import Icon from 'common/components/Icon';
import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import { StoreBasicDataApiStructure, } from 'common/types';
import { repositories, } from 'api';
import { productsOperations, } from 'store/ducks/products/collection';
import { PaginationDesktop, PaginationMobile, } from './components/Pagination';
import { ProductsFilterStore, } from 'store/ducks/products/collection/types';
import { useUpdateFilterSearchParams, } from 'common/hooks';

type Limit = {
    Icon: React.FC,
    limit: number,
};

const limits = [
    {
        Icon: () => (<Icon.PaginationListLevel1 />),
        limit: 10,
    },
    {
        Icon: () => (<Icon.PaginationListLevel3 />),
        limit: 20,
    },
    {
        Icon: () => (<Icon.PaginationListLevel4 />),
        limit: 70,
    },
];

type Props = Omit<repositories.products.CollectionTypes.ProductsType, '_links' | 'items' | 'page' | 'limit' | 'total'> & {
    fetchProducts: Function,
    filters: ProductsFilterStore['filters'],
};

const ProductsPaginationBar: React.FC<Props> = ({
    pages,
    fetchProducts,
    filters,
}) => {
    const updateFilter = useUpdateFilterSearchParams();

    const handleChangeVisibilityLimit = useCallback(
        (limit: number) => () => {
            fetchProducts({ limit, });

            updateFilter({ ...filters, limit, });
        },
        [ updateFilter, fetchProducts, filters, ]
    );

    const renderLimits = useCallback(({ Icon, limit, }: Limit) => (
        <Button key={limit}
                onClick={handleChangeVisibilityLimit(limit)}
                endIcon={<Icon />}>
            {limit}
        </Button>
    ), [ handleChangeVisibilityLimit, ]);

    const updateProducts = useCallback((page: number) => {
        fetchProducts({ page, });

        updateFilter({ ...filters, page, });
    },
        [ fetchProducts, filters, updateFilter, ]
    );

    const handleChangePage = useCallback(
        (event: object, page: number) => {
            updateProducts(page);
        },
        [ updateProducts, ]
    );

    return (
        <Paper elevation={DEFAULT_PAPER_ELEVATION}>
            <Box p={1}>
                <PaginationDesktop page={filters.page}
                                   limits={limits.map(renderLimits)}
                                   pages={pages}
                                   handleChangePage={handleChangePage} />
                <PaginationMobile page={filters.page}
                                  updateProducts={updateProducts}
                                  pages={pages} />
            </Box>
        </Paper>
    );
};

type MappingType = {
    products: {
        collection: StoreBasicDataApiStructure<repositories.products.CollectionTypes.ProductsType> & ProductsFilterStore,
    },
};

const mapStateToProps = ({ products, }: MappingType) => {
    const data = products.collection.data;
    const filters = products.collection.filters;

    return {
        pages: data?.pages,
        filters,
    };
};

const mapDispatchToProps = {
    fetchProducts: productsOperations.request,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductsPaginationBar);
